import { ScheduledAodRunDto } from '@app/modules/audit/modules/aod/aod.types';
import {
  auditReportsGetAodRulesScheduledRunsQueryKey,
  useAuditReportsTriggerManualRunFromScheduledAodRules,
} from '@mi-front/api-v2';
import { useToast } from '@app/core/notifications';
import NotStartedIcon from '@mui/icons-material/NotStarted';
import { IconButton, Tooltip } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useIntl } from 'react-intl';

export function AodScheduledRunActions({
  scheduledRun,
  ruleId,
}: {
  scheduledRun: ScheduledAodRunDto;
  ruleId: string;
}) {
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const { notifySuccess } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const triggerManualRunMutation = useAuditReportsTriggerManualRunFromScheduledAodRules();

  const handleTriggerRun = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    try {
      await triggerManualRunMutation.mutateAsync({
        scheduledJobId: scheduledRun.jobId,
      });

      // Invalidate scheduled runs queries to refresh the data
      queryClient.invalidateQueries({
        queryKey: auditReportsGetAodRulesScheduledRunsQueryKey(ruleId),
      });

      notifySuccess(
        formatMessage({
          id: 'audit.aod.runs.actions.triggerRunCopySuccess',
          defaultMessage: 'Ejecución iniciada',
        }),
      );
    } catch (error) {
      console.error('Failed to trigger manual run:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Tooltip
      title={formatMessage({
        id: 'audit.aod.runs.actions.triggerRunCopy',
        defaultMessage: 'Ejecutar copia ahora',
      })}
    >
      <IconButton onClick={handleTriggerRun} disabled={isLoading} color="primary">
        <NotStartedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
